import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';
import { String } from 'core-js';

@Component({
  selector: 'app-StudentComplianceReport_Level_1_',
  templateUrl: './StudentComplianceReport_Level_1_.component.html',
  styleUrls: ['./StudentComplianceReport_Level_1_.component.css']
})
export class StudentComplianceReport_Level_1_Component implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  isReportButtonDisabled: boolean;
  date: Date; //datepicker
  //dropdown selection
  selectedAcademicYear: SelectItem;
  selectedAttendancePeriod: SelectItem;
  selectedPAU: SelectItem;
  selectedSite: SelectItem;
  selectedStudent: SelectItem;

  _academicYear: string = null;
  _attendancePeriod: string = null;
  _PAUid: string = null;
  _siteId: string = null;
  _studentId: string = null;
  acYear: string = null;

  public showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  academicYearList: ILookupBase[] = [{ value: null, label: "-- Select Academic Year --", shortText: null, updatedOn: null }];
  attendancePeriodList: ILookupBase[] = [{ value: null, label: "-- Select Attendance Period --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }];
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupStudentList: ILookupBase[] = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
  }


  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadAllLookupValues();
    this.isReportButtonDisabled = true;
  }

  LoadAllLookupValues(): void {
    this._lookupService.getLookupAcademicYearList(this._baseUrl + 'api/Lookup/GetAcademicYearList/')
      .subscribe((res: ILookupBase[]) => {
        this.academicYearList = [{ value: null, label: "-- Select Academic Year --", shortText: null, updatedOn: null }].concat(res.reverse());
        this.selectedAcademicYear = this.academicYearList[0];
        this.acYear = (new Date().getMonth() + 1) > 7 ? new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) : (new Date().getFullYear() - 1) + "-" + new Date().getFullYear();
        this._lookupService.getLookupAttendancePeriod(this._baseUrl + 'api/Lookup/GetAttendancePeriodList/' + (this._academicYear == null ? this.acYear : this._academicYear))
          .subscribe((res: ILookupBase[]) => {
            this.attendancePeriodList = [{ value: null, label: "-- Select Attendance Period --", shortText: null, updatedOn: null }].concat(res.reverse());
            this.selectedAttendancePeriod = this.attendancePeriodList[0] as SelectItem;
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }

        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Student lookup
              let params = {} as IStudentSearchParameters;
              params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
              params.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetStudentList/', params)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
                  }
                  else {
                    this.lookupStudentList = [{ value: 'All', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
                    this.selectedStudent = this.lookupStudentList[0];
                  }
                },
                  err => console.error(err)
                );

            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
  }

  LoadLookupValuesAttendancePeriodOnwards() {
    this._lookupService.getLookupAttendancePeriod(this._baseUrl + 'api/Lookup/GetAttendancePeriodList/' + (this._academicYear == null ? this.acYear : this._academicYear))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.attendancePeriodList = [{ value: null, label: "-- NO ATTENDANCE PERIODS TO VIEW ! --", shortText: null, updatedOn: null }]
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }];
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
        }
        else {
          this.attendancePeriodList = [{ value: null, label: "-- Select Attendance Period --", shortText: null, updatedOn: null }].concat(res.reverse());
          this.selectedAttendancePeriod = this.attendancePeriodList[0] as SelectItem;
          this.LoadLookupValuesPAUOnwards();
        }
      },
        err => console.error(err)
      );
  }

  LoadLookupValuesPAUOnwards() {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }];
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
          this.LoadLookupValuesSitesOnwards();
        }
      },
        err => console.error(err)
      );
  }

  LoadLookupValuesSitesOnwards() {
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];
          this.LoadLookupValuesStudents();
        }
      },
        err => console.error(err)
      );
  }

      //Student lookup
  LoadLookupValuesStudents() {
    let params = {} as IStudentSearchParameters;
    params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
    params.siteIdArray = this.getSiteIdList().split('^');
    this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetStudentList/', params)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupStudentList = [{ value: 'All', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
          this.selectedStudent = this.lookupStudentList[0];
        }
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];
        }
      },
        err => console.error(err)
      );
  }

  LookupStudents(id): void {
    this._siteId = id.value;
    let params = {} as IStudentSearchParameters;
    params.asOfDate = this.date;
    params.siteIdArray = [this._siteId];

    this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetStudentList/', params)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupStudentList = [{ value: 'All', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
          this.selectedStudent = this.lookupStudentList[0];
        }
      },
        err => console.error(err)
      );
  }



  setAcademicYear(id): void {
    this.acYear = id.value;
    this.LoadLookupValuesAttendancePeriodOnwards()
    this.ControlReportButtonEnablement();
  }
  setAttendancePeriod(id): void {
    this.ControlReportButtonEnablement();
  }



  setStudent(id): void {
    this._studentId = id.value;
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

    getPAUIdList(): string {
      let pauIdList: string;
      this.lookupPAUList.forEach((pau, index, arr) => {
        if ((pau.label != null) && (pau.label != "-- NO PAUS ! --")) {
          if (pau.label != "-- All PAUs --") pauIdList += pau.value + '^';
      }
      });
      return pauIdList.slice(0, pauIdList.length - 1).replace('undefined', '').replace('null^', '');
  }

  getstudentIdList(): string {
    let studentIdList: string;
    this.lookupStudentList.forEach((std, index, arr) => {
      if ((std.label != null) && (std.label != "-- NO STUDENTS TO VIEW --")) {
        if (std.label != "-- All Students --") studentIdList += std.value + '^';
      }
    });
    return studentIdList.slice(0, studentIdList.length - 1).replace('undefined', '');
  }


  ControlReportButtonEnablement() {
    if (this.selectedAcademicYear == null) {
      this.isReportButtonDisabled = true;
    }
    else {
      if (this.selectedAttendancePeriod != null && this.attendancePeriodList.find(k => k.value === this.selectedAttendancePeriod.toString()).value != null)
      this.isReportButtonDisabled = false;
    }
  }
   
  viewReport() {
    let reportParamArray: IReportParameter[] = [];

    var key = "";
    var selectedAcademicYearValue = "";
    var selectedAttendacePeriodValue = "";
    var selectedPAUIdList = "";
    var selectedSiteIdList = "";
    var selectedLocalStudentId = "All";
    var selectedStartingDate = "";
    var selectedEndingDate = "";
    var selectedPAU_Name = "All PAUs";
    var selectedSiteName = "All Sites";
    var selectedStudentName = "All Students";

    if (this.selectedAcademicYear.label === undefined) {
      selectedAcademicYearValue = this.selectedAcademicYear.toString();
    }
    else {
      selectedAcademicYearValue = this.selectedAcademicYear.value;
    }

    if (this.selectedAttendancePeriod.label === undefined) {
      key = this.selectedAttendancePeriod.toString();
    } else {
      key = this.selectedAttendancePeriod.value;
    }

    for (var item of this.lookupPAUList) {
      if (item.value != null)
        selectedPAUIdList = selectedPAUIdList + item.value + '^';
    }

    if (selectedPAUIdList.length > 1 && selectedPAUIdList.slice(selectedPAUIdList.length - 1, selectedPAUIdList.length) == '^') {
      selectedPAUIdList = selectedPAUIdList.slice(0, selectedPAUIdList.length - 1);
    }

    for (var item of this.lookupSiteList) {
      if (item.value != null)
        selectedSiteIdList = selectedSiteIdList + item.value + '^';
    }

    if (selectedSiteIdList.length > 1 && selectedSiteIdList.slice(selectedSiteIdList.length - 1, selectedSiteIdList.length) == '^') {
      selectedSiteIdList = selectedSiteIdList.slice(0, selectedSiteIdList.length - 1);
    }

    selectedAttendacePeriodValue = this.attendancePeriodList.find(k => k.value === key).label;
    selectedStartingDate = selectedAttendacePeriodValue.slice(selectedAttendacePeriodValue.indexOf('-') + 2, selectedAttendacePeriodValue.indexOf('-') + 12);
    selectedEndingDate = selectedAttendacePeriodValue.slice(selectedAttendacePeriodValue.indexOf('to ') + 3, selectedAttendacePeriodValue.indexOf('to ') + 13);

    if (this.selectedPAU.label === undefined) {
      selectedPAUIdList = this.selectedPAU.toString();
      if (selectedPAUIdList != '-- ALL PAUs --') {
        selectedPAU_Name = this.lookupPAUList.find(k => k.value === selectedPAUIdList).label;
      }
    } else {
      if (this.selectedPAU.label != '-- ALL PAUs --') {
        selectedPAUIdList = this.selectedPAU.value;
        selectedPAU_Name = this.lookupPAUList.find(k => k.value === selectedPAUIdList).label;
      }
    }

    if (this.selectedSite.label === undefined) {
      selectedSiteIdList = this.selectedSite.toString();
      if (this.selectedSite.label != '-- All Sites --') {
        selectedSiteName = this.lookupSiteList.find(k => k.value === selectedSiteIdList).label;
      }
    } else {
      if (this.selectedSite.label != '-- All Sites --') {
        selectedSiteIdList = this.selectedSite.value;
        selectedSiteName = this.lookupSiteList.find(k => k.value === selectedSiteIdList).label;
      }
    }

    if (this.selectedStudent.label === undefined) {
      selectedLocalStudentId = this.selectedStudent.toString();
      if(selectedLocalStudentId != '-- All Students --') {
        selectedStudentName = this.lookupStudentList.find(k => k.value === selectedLocalStudentId).label;
      }
    } else {
      if (this.selectedStudent.label != '-- All Students --') {
        selectedLocalStudentId = this.selectedStudent.value;
        selectedStudentName = this.lookupStudentList.find(k => k.value === selectedLocalStudentId).label;
      }
    }

    reportParamArray.push(
      { parameterName: 'AcademicYear', parameterValue: selectedAcademicYearValue },
      { parameterName: 'AttendancePeriod', parameterValue: selectedAttendacePeriodValue }, 
      { parameterName: 'PAUIdList', parameterValue: selectedPAUIdList }, 
      { parameterName: 'SiteIdList', parameterValue: selectedSiteIdList }, 
      { parameterName: 'LocalStudentId', parameterValue: selectedLocalStudentId }, 
      { parameterName: 'StartingDate', parameterValue: selectedStartingDate }, 
      { parameterName: 'EndingDate', parameterValue: selectedEndingDate }, 
      { parameterName: 'PAU_Name', parameterValue: selectedPAU_Name }, 
      { parameterName: 'SiteName', parameterValue: selectedSiteName }, 
      { parameterName: 'StudentName', parameterValue: selectedStudentName } 
    );

    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_SpecialEdStudentComplianceReport";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
